import { RentalConditions } from '@ha/api/v2/types/RentalConditions';

import { PricingStructure } from './types';

/**
 * pass the source-of-truth parameters when applicable
 * LDP, ListingEdit and ContactAdvertiser: advertiser
 * other: rentalConditions
 */
export function getPricingStructure({
  advertiser,
  rentalConditions,
}: {
  advertiser?: {} | null;
  rentalConditions?: Pick<RentalConditions, 'isLegacy'> | null;
}) {
  if (rentalConditions) {
    return !rentalConditions.isLegacy
      ? PricingStructure.instalment
      : PricingStructure.monthly;
  }

  if (advertiser) {
    return PricingStructure.instalment;
  }

  return PricingStructure.monthly;
}
